import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addUserWheelAction,
  removePendingWheel,
} from "../../redux/actions/wheels";
import { getAiWheel } from "../../services/api";
import { ASSETS } from "../../utils/config";
import CloseIcon from "@mui/icons-material/Close";

const ProgressBarItem = ({ item, totalItems, setViewAll, viewAll }) => {
  const [progress, setProgress] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [loading, setLoading] = useState(true);
  const [wheelId, setWheelId] = useState(null);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [totalDuration, setTotalDuration] = useState(240000);
  const [showCloseIcon, setShowCloseIcon] = useState(false);

  const dispatch = useDispatch();

  const { startTime, temp_id, prompt, inProgress } = item;

  const nav = useNavigate();

  const onViewWheel = (clicked = false) => {
    if (clicked && wheelId) {
      nav(`/wheel/${wheelId}/null/${temp_id}`);
      return;
    }
    getAiWheel(temp_id)
      .then((res) => {
        const { in_progress, status, message } = res.data;
        setMessage(message);
        setLoading(false);
        if (in_progress && status) {
          setError(false);
          const timeDifference = Date.now() - new Date(startTime);
          if (timeDifference > 200000) {
            setCompleted(false);
            setTotalDuration(totalDuration + 15000); //increase 15 seconds if the wheel is still not created
          }
        } else if (!status && !in_progress) {
          setCompleted(false);
          setError(true);
          setTotalDuration(0);
        }
        if (
          status == true &&
          in_progress == false &&
          message === "AI wheel generated!"
        ) {
          setCompleted(true);
          setError(false);
          console.log(res?.data, "res?.data");
          dispatch(addUserWheelAction(res?.data));
          setWheelId(res?.data?.id);
        }
      })
      .catch((err) => {
        setError(true);
        setTotalDuration(0);
        console.log(err);
      });
  };

  useEffect(() => {
    let intervalId;

    const fetchWheelData = () => {
      onViewWheel();
    };

    console.log({ completed, error });

    if (!completed && !error) {
      console.log("hassan executing fetch wheel data on mount", completed);
      fetchWheelData(); // Initial call
      intervalId = setInterval(fetchWheelData, 15000); // Set interval
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
        console.log("is point pe redux se hata do "); // Clear interval on cleanup
      }
    };
  }, [completed, error]); // Add `completed` as a dependency
  //

  // useEffect(() => {
  //   onViewWheel();
  //   let intervalId;
  //   if (intervalId && (completed || totalDuration == 0)) {
  //     clearInterval(intervalId);
  //   }

  //   intervalId = setInterval(() => {
  //     onViewWheel();
  //   }, 15000);
  //   return () => clearInterval(intervalId);
  // }, []);

  useEffect(() => {
    const timeDifference = Date.now() - new Date(startTime);
    let timerInterval;
    const cleanup = () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };

    cleanup();

    if (timeDifference < totalDuration) {
      timerInterval = setInterval(() => {
        const elapsedTime = Date.now() - new Date(startTime);

        const remainingTimeInSeconds = Math.ceil(
          (totalDuration - elapsedTime) / 1000
        );

        if (remainingTimeInSeconds <= 0) {
          cleanup();
        } else {
          let percentage = (elapsedTime / totalDuration) * 100;
          setProgress(Math.min(100, percentage));
        }
      }, 1000);
    } else {
      cleanup();
      console.log("The difference is greater than 4 minutes.");
    }

    return cleanup;
  }, [totalDuration]);

  return (
    <div
      onMouseOver={() => setShowCloseIcon(true)}
      onMouseOut={() => setShowCloseIcon(false)}
      style={{
        backgroundColor: "#e0e0e0",
        backgroundImage: `url(${ASSETS.gradientBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        borderRadius: "20px",
        padding: "20px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        marginBottom: 10,
        position: "relative",
      }}
    >
      {!viewAll ? (
        <div
          onClick={setViewAll}
          style={{
            position: "absolute",
            borderRadius: 10,
            border: "1px solid black",
            fontFamily: "DM Sans",
            fontSize: "8px",
            height: 20,
            bottom: 0,
            backgroundColor: "#f6f7f9",
            alignItems: "center",
            justifyContent: "center",
            padding: 4,
            display: "flex",
            flexDirection: "row",
            zIndex: 100,
            pointerEvents: "auto",
            cursor: "pointer",
          }}
        >
          <Typography
            variant="subtitle2"
            component="subtitle2"
            style={{
              fontFamily: "DM Sans",
              fontWeight: "500",
              fontSize: "12px",
              color: "#123051",
              paddingLeft: 5,
            }}
          >
            {totalItems - 1} More
          </Typography>

          <KeyboardArrowDownIcon />
        </div>
      ) : null}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <img
            src={error ? ASSETS.aiError : ASSETS.aiBot}
            alt="AiIcon"
            style={{ height: "30px", width: "30px", marginRight: "8px" }}
          />
        </div>

        <div>
          <Typography
            variant="subtitle2"
            component="subtitle2"
            style={{
              fontFamily: "DM Sans",
              fontWeight: "600",
              fontSize: "12px",
              color: "#123051",
              marginRight: 5,
              display: "-webkit-box",
              overflow: "hidden",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
            }}
          >
            {error
              ? "There was an error"
              : completed
              ? "The wheel is ready!"
              : prompt}
          </Typography>
          {!completed && message ? (
            <Typography
              variant="subtitle2"
              component="subtitle2"
              style={{
                fontFamily: "DM Sans",
                fontWeight: "500",
                fontSize: "9px",
                color: "#123051",
                marginRight: 5,
                display: "-webkit-box",
                overflow: "hidden",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {`${message}...`}
            </Typography>
          ) : null}
        </div>
      </div>
      <div>
        {!completed && !error ? (
          <div style={{ height: "32px", width: "32px" }}>
            <CircularProgressbar
              value={progress}
              text={`${Math.floor(progress)}%`}
              styles={buildStyles({
                rotation: 0,
                strokeLinecap: "butt",
                textSize: "30px",
                fontWeight: "400",
                pathTransitionDuration: 0.5,
                pathColor: `#123051`,
                textColor: "#123051",
                trailColor: "#d6d6d6",
                backgroundColor: "#3e98c7",
              })}
            />
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {completed ? (
              <button
                onClick={() => onViewWheel(true)}
                style={{
                  backgroundColor: "white",
                  border: "0.5px solid black",
                  borderRadius: "5px",
                  padding: "4px",
                  fontFamily: "DM Sans",
                  margin: "auto",
                  fontSize: "8px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              >
                {"View wheel"}
              </button>
            ) : error ? (
              <button
                onClick={() => onViewWheel(true)}
                style={{
                  backgroundColor: "white",
                  border: "0.5px solid black",
                  borderRadius: "5px",
                  padding: "4px",
                  fontFamily: "DM Sans",
                  margin: "auto",
                  fontSize: "8px",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              >
                {"Load again"}
              </button>
            ) : null}
          </div>
        )}
      </div>
      {showCloseIcon ? (
        <div
          style={{
            position: "absolute",
            right: -5,
            marginTop: -70,
            backgroundColor: "white",
            width: 20,
            height: 20,
            borderRadius: 15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
        >
          <CloseIcon
            onClick={() => dispatch(removePendingWheel(temp_id))}
            style={{
              fontSize: "12px",
              color: "#373737",
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

export default ProgressBarItem;
